import { render } from "./ProgramsCardComponent.vue?vue&type=template&id=5b1f2dfc"
import script from "./ProgramsCardComponent.vue?vue&type=script&lang=js"
export * from "./ProgramsCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__